import React from 'react';
import App from '../App/App';
import {Cards, ImageLayer, ProductBanner} from '../../components';
import ValueCard from './ValueCard';
import FuncCard from './FuncCard';
import {banner, value, func, structure} from './config';

export default function ProductEPLD() {
  if (!global.isServer) {
    document.title = '物流控制塔-全链全渠道供应链控制塔指挥系统';
  }
  return (
    <App className='ProductEPLD'>
      <ProductBanner data={banner}/>
      <Cards title='核心价值' data={value} lg={3} md={2} grey size='middle'>
        <ValueCard />
      </Cards>
      <Cards title='功能模块' data={func} md={4} lm={2} size='middle'>
        <FuncCard />
      </Cards>
      <ImageLayer title='功能架构' src={structure} grey size='middle'/>
    </App>
  );
};



// WEBPACK FOOTER //
// ./src/routes/ProductEPLD/ProductEPLD.js